<template>
    <div class="container">
        <div class="content">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getbottom"
                :immediate-check="false" :offset="10"
                >
                <div class="cktime" v-for="(item,index) in CheckList" :key="index" @click="goCkDetail(item.id,item.state,item.experience_id,item.is_sign)">
                    <div class="time">{{item.created_at}}</div>
                    <div class="imgbox">
                        <img v-if="item.state != 1" src="@/assets/images/user/prospect/chevron-down.png" alt="">
                        <span v-else>未点检</span>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>
<script>
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
export default {
    name: "cktime",
    data () {
        return {
            optionCount:{
                page:0,
                limit:20,
            },
            loading:false,
            finished:false,
            project_id:'',//存储体验间名字
        }
    },
    computed : {
        CheckList () {
            return this.$store.state.userTalkAppointV2.CheckList
        }
    },
    created () {
        fetchVerifyAuthForB (() => {
            let { project_id } = this.$route.query
            this.project_id = project_id
            this.$store.dispatch({type:'userTalkAppointV2/getCheckList3',project_id:project_id,search_state:-1,...this.optionCount})
        })
        
    },
    methods : {
        goCkDetail (id,state,id2,sign){
           console.log('平台管理:23' + this.$store.state.userTalkAppointV2.BIdentity);

            // 点检状态 0待点检 1未点检 2问题事项  3已点检
            // 问题事项、已点检：查看点检记录  待点检：点击就是填写点检记录（默认永远在最上面）
            // 未点检：单纯状态无法点击（不可补）
            console.log(state,'state');
            if (state == 1) {
                return 
            } else if (state == 2 ||state == 3) {
                // type 1 查看.type 2 填写
                // id:点检id
                // id2:体验间id
                this.$router.push(`/hvac/talk/ckdetail?type=1&id=${id}&id2=${id2}`)
            } else if(state == 0) {
                // 如果是负责人可以点检,可以查看
                // 如果是管理员,那么就只能查看,不能点检,
                // 如果又是负责人又是管理员可以点检
                if (sign == 1) {
                    // const date = new Date()
                    // let week = date.getDay()
                    // console.log(week,'week');
                    // 判断今天 周几,如果是一三五可以点检,如果是其他的,不可以点检
                    // if ( week %2 == 0) {
                    //     this.$toast('只有周一,周三,周五能进行点检')
                    //     return
                    // }
                    this.$router.push(`/hvac/talk/ckdetail?type=2&id=${id}&id2=${id2}`)
                } else {
                    console.log(sign,'sign');
                    this.$toast("抱歉,您无法点检")
                    return
                }
            }
        },
        getbottom () {
            this.loading = true
            let length = this.CheckList.length
            this.optionCount.page += 1
            this.$store.dispatch({type:'userTalkAppointV2/getCheckList4',search_project:this.project_id,...this.optionCount}).then (() => {
                if (this.CheckList.length == length) {
                    this.finished = true
                }
                this.loading = false
            })
        }
    }
};
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}
.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}
.container {
    width: 100%;
    height: 100%;
    padding: 24px;
    background: #F0F4F1;
    .content {
        width: 100%;
        .cktime {
            margin-top: 20px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content:space-between;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 28px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #444444;
            img {
                width: 32px;
                height: 32px;
                transform: rotate(-90deg);
            }
        }
    }
}
</style>
